import { NavLink } from 'react-router-dom';
import { Home, LayoutGrid, Package, Mic, ShoppingBag, BookOpen, UserCircle } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { useCart } from '../lib/cart';

export const openVoiceOrder = () => window.dispatchEvent(new CustomEvent('mandispot:voice-order'));

const TABS = [
  { to: '/', label: 'Home', Icon: Home, end: true, id: 'home' },
  { to: '/categories', label: 'Categories', Icon: LayoutGrid, id: 'categories' },
  { to: '/orders', label: 'Orders', Icon: Package, id: 'orders', auth: true },
  { voice: true, id: 'voice' },
  { to: '/cart', label: 'Cart', Icon: ShoppingBag, id: 'cart' },
  { to: '/khata', label: 'Khata', Icon: BookOpen, id: 'khata', auth: true },
  { to: '/profile', label: 'Account', Icon: UserCircle, id: 'account', auth: true },
];

const itemCls = ({ isActive }) =>
  `relative flex flex-col items-center justify-center gap-0.5 h-full text-[10px] font-bold transition-colors ${
    isActive ? 'text-[#D35400]' : 'text-ink/60'
  }`;

export default function BottomNav() {
  const { user } = useAuth();
  const { totals } = useCart();
  const askLogin = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('mandispot:open-auth', { detail: { mode: 'signin' } }));
  };

  return (
    <nav data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 h-16 bg-white/95 backdrop-blur-xl border-t-2 border-ink/10 grid grid-cols-7 pb-[env(safe-area-inset-bottom)]">
      {TABS.map((t) => t.voice ? (
        <button key="voice" data-testid="bottom-nav-voice" onClick={openVoiceOrder} aria-label="Voice order"
          className="flex flex-col items-center justify-start -mt-5">
          <span className="w-14 h-14 rounded-full bg-[#1B5E20] text-white grid place-items-center shadow-lg ring-4 ring-white active:scale-95 transition-transform">
            <Mic className="w-6 h-6"/>
          </span>
          <span className="text-[10px] font-black text-[#1B5E20] mt-0.5">Bolo</span>
        </button>
      ) : (
        <NavLink key={t.id} to={t.to} end={t.end} data-testid={`bottom-nav-${t.id}`}
          onClick={t.auth && !user ? askLogin : undefined} className={itemCls}>
          <t.Icon className="w-5 h-5"/>
          {t.label}
          {t.id === 'cart' && totals.allCount > 0 && (
            <span data-testid="bottom-nav-cart-count"
              className="absolute top-1.5 right-1/2 translate-x-4 bg-[#E67E22] text-white text-[9px] rounded-full min-w-[16px] h-4 grid place-items-center px-1">
              {totals.allCount}
            </span>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
